// function rating() {
//   var yotpoRating = document.querySelectorAll('.yotpo.bottomLine .yotpo-stars > .sr-only');
  
//   for (var i = 0; i < yotpoRating.length; i++) {
//     var ratingText = yotpoRating[i].innerHTML;
//     var ratingValue = ratingText.match(/[\d.]+/)[0];
//     var ratingNoText = ratingText.replace(ratingValue + " star rating", ratingValue);
  
//     yotpoRating[i].innerHTML = ratingNoText;
//   }
// }

// setTimeout(rating, 50)

// function reviews() {
//   var yotpoReviews = document.querySelectorAll('.yotpo.bottomLine .yotpo-bottomline > a.text-m');
  
//   for (var i = 0; i < yotpoReviews.length; i++) {
//     var reviewText = yotpoReviews[i].innerHTML;
//     var reviewValue = reviewText.match(/[\d.]+/)[0];
//     var reviewNoText = reviewText.replace(reviewValue + " Reviews", reviewValue);
  
//     yotpoReviews[i].innerHTML = reviewNoText;
//   }
// }

// setTimeout(reviews, 50)

// This function is for custom-banner.liquid

var switchCustomBanner = (container) => {
  const scrollContainer = container.querySelector('[js-scroll-container]');
  const paginationDots = container.querySelector('[js-pagination-dots]');
  const milliseconds = parseInt(scrollContainer.getAttribute('js-slide-time'));
  setInterval(() => {
    const currentIndex = parseInt(scrollContainer.getAttribute('js-current-id'));
    const totalIndex = parseInt(scrollContainer.getAttribute('js-total-id'));
    var nextIndex = (currentIndex + 1) % totalIndex;
    var nextElement = scrollContainer.querySelector('[js-data-id="'+nextIndex+'"]');
    scrollContainer.scrollTo(nextElement.offsetLeft, 0);
    paginationDots.querySelector('.active').classList.remove('active');
    paginationDots.querySelector('[js-data-id="'+nextIndex+'"]').classList.add('active');
    scrollContainer.setAttribute('js-current-id', nextIndex);
  }, milliseconds);
}

var clickPaginationDot = (element) => {
  const paginationDots = element.closest('[js-pagination-dots]');
  const container = paginationDots.closest('[js-container]').querySelector('[js-scroll-container]');
  paginationDots.querySelector('.active').classList.remove('active');
  element.classList.add('active');
  container.setAttribute('js-current-id', element.getAttribute('js-data-id'));
  var scrollLeft = container.querySelector('.block[js-data-id="'+element.getAttribute('js-data-id')+'"]').offsetLeft - parseInt(window.getComputedStyle(container, null).getPropertyValue('padding-left'));
  container.scrollTo(scrollLeft, 0)
}

var mobileMoveSlide = (container, direction) => {
  var currentIndex = parseInt(container.querySelector('[js-scroll-container]').getAttribute('js-current-id'));
  var totalIndex = parseInt(container.querySelector('[js-scroll-container]').getAttribute('js-total-id'));
  var nextIndex;
  if (direction == true) {
    nextIndex = currentIndex + 1;
  } else {
    nextIndex = currentIndex - 1;
  }
  if (nextIndex < 0 || nextIndex >= totalIndex) return;
  container.querySelector('[js-pagination-dots] [js-data-id="'+nextIndex+'"]').click();
}

// This function is for custom-slideshow.liquid
// if direction is true then scrollTo positive
// else if direction is false then scrollTo negative
var switchCustomSlideshow = (container, direction) => {
  var currentIndex = parseInt(container.getAttribute('js-current-id'));
  var totalIndex = parseInt(container.getAttribute('js-total-id'));
  var nextIndex;
  if (direction == true) {
    nextIndex = (currentIndex + 1) % totalIndex;
  } else {
    nextIndex = currentIndex - 1;
  }
  if (nextIndex < 0) nextIndex = totalIndex - 1;
  container.setAttribute('js-current-id', nextIndex);
  if (container.closest('[js-container]').querySelector('[js-pagination-dots]')) {
    container.closest('[js-container]').querySelector('[js-pagination-dots] [js-data-id="'+nextIndex+'"]').click();
  } else {
    container.scrollTo(container.querySelector('[js-scroll-container] [js-data-id="'+nextIndex+'"]').offsetLeft, 0);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[anchor-to-featured-product]').forEach(element => {
    element.addEventListener('click', () => {
    });
  });
  Array.from(document.querySelectorAll('.product-info__tabs .tab-headers>div')).forEach((element) => {
    element.addEventListener('click', () => {
      const container = element.closest('.product-info__tabs');
      container.querySelector('.tab-headers>div.active').classList.remove('active');
      element.classList.add('active');
      container.querySelector('.tab-content.active').classList.remove('active');
      container.querySelector('.tab-content[data-id="'+element.getAttribute('data-id')+'"]').classList.add('active');
    });
  });
  
  document.querySelectorAll('.section__custom-banner__container').forEach((container) => {
    switchCustomBanner(container);
  });

  document.querySelectorAll('[js-container] [js-scroll-left-button]').forEach(element => {
    element.addEventListener('click', () => {
      const container = element.closest('[js-container]').querySelector('[js-scroll-container]');
      switchCustomSlideshow(container, false);
    });
  });
  document.querySelectorAll('[js-container] [js-scroll-right-button]').forEach(element => {
    element.addEventListener('click', () => {
      const container = element.closest('[js-container]').querySelector('[js-scroll-container]');
      switchCustomSlideshow(container, true);
    });
  });

  document.querySelectorAll('[js-video-element]').forEach((element) => {
    element.addEventListener('click', () => {
      if (element.querySelector('video')) {
        if (element.querySelector('.video-button').classList.contains('playing')) {
          element.querySelector('.video-button').classList.remove('playing');
          element.querySelector('video').pause();
        } else {
          element.querySelector('.video-button').classList.add('playing');
          element.querySelector('video').play();
        }
      }
    });
  });
  document.querySelectorAll('[js-pagination-dots]>span').forEach((element) => {
    element.addEventListener('click', () => {
      clickPaginationDot(element);
    })
  });
  document.querySelectorAll('[js-prev-button]').forEach((element) => {
    element.addEventListener('click', () => {
      const container = element.closest('.section__custom-video-slider__container');
      const dot = container.querySelector('[js-pagination-dots]>[js-data-id="'+(parseInt(container.querySelector('[js-scroll-container]').getAttribute('js-current-id'))-1)+'"]');
      if (dot) {
        clickPaginationDot(dot);
      }
    });
  });
  document.querySelectorAll('[js-next-button]').forEach((element) => {
    element.addEventListener('click', () => {
      const container = element.closest('.section__custom-video-slider__container');
      const dot = container.querySelector('[js-pagination-dots]>[js-data-id="'+(parseInt(container.querySelector('[js-scroll-container]').getAttribute('js-current-id'))+1)+'"]');
      if (dot) {
        clickPaginationDot(dot);
      }
    });
  });

  var scrollPos = [];
  document.querySelectorAll('[js-scroll-container]').forEach((element, index) => {
    scrollPos.push(0);
    element.addEventListener('touchstart', () => {
      scrollPos[index] = element.scrollLeft;
    });
    element.addEventListener('touchend', () => {
      if (element.scrollLeft > scrollPos[index]) {
        mobileMoveSlide(element.closest('[js-container]'), true);
      } else if (element.scrollLeft < scrollPos[index]) {
        mobileMoveSlide(element.closest('[js-container]'), false);
      }
    });
    element.addEventListener('touchcancel', () => {
      if (element.scrollLeft > scrollPos[index]) {
        mobileMoveSlide(element.closest('[js-container]'), true);
      } else if (element.scrollLeft < scrollPos[index]) {
        mobileMoveSlide(element.closest('[js-container]'), false);
      }
    });
  });

  document.querySelectorAll('[js-scroll-container][auto-scroll]').forEach((element) => {
    var delayFlag = 200;
    var stopFlag = false;
    setInterval(() => {
      if (stopFlag || window.innerWidth < 1000) return;
      if (delayFlag < 200) {
        delayFlag++;
      } else {
        var newScrollLeft = element.scrollLeft + 8;
        if (newScrollLeft > element.scrollWidth - element.clientWidth) {
          newScrollLeft = 0;
          delayFlag = 0;
        }
        if (element.getBoundingClientRect().y > (-1 * element.getBoundingClientRect().height) && element.getBoundingClientRect().y < window.innerHeight)
          element.scrollTo(newScrollLeft, 0);
      }
    }, 20);
    element.addEventListener('mouseenter', () => {
      stopFlag = true;
    });
    element.addEventListener('mouseleave', () => {
      stopFlag = false;
    });
  });

  document.querySelectorAll('button[data-pf-type="ProductATC2"]').forEach(element => {
    element.addEventListener('click', () => {
      setTimeout(() => {
        var event = new CustomEvent('cart:refresh');
        document.dispatchEvent(event);
      }, 2000);
    });
  });

  setInterval(() => {
    document.querySelectorAll('cart-drawer .empty-state .prose a.button').forEach(element => {
      let featuredProductSection;
      const pureProductSection = document.querySelector('#shopify-section-template--17022516527264__custom_featured_product_TUXUn3');
      if (pureProductSection)
        featuredProductSection = pureProductSection;
      const fuelProductSection = document.querySelector('#shopify-section-template--17093428510880__custom_featured_product_TUXUn3');
      if (fuelProductSection)
        featuredProductSection = fuelProductSection;
      if (featuredProductSection) {
        element.removeAttribute('href');
        element.style.cursor = 'pointer';
        element.addEventListener('click', () => {
          element.closest('cart-drawer').querySelector('button[is="close-button"]').click();
          document.querySelector('html').scrollTo(0, featuredProductSection.offsetTop);
        });
      }
    });
  }, 100);

  document.querySelectorAll('[js-anchor-link]').forEach(element => {
    element.addEventListener('click', (e) => {
      e.preventDefault();
      const targetElement = document.querySelector(element.getAttribute('href'));
      if (targetElement == undefined) return;
      document.querySelector('html').scrollTo(0, targetElement.offsetTop);
    });
  });
});